import React, { memo } from 'react';

import classes from './Icons.module.scss';

export const IconArrowUp = ({
  className,
  fill,
  height,
  stroke,
  strokeWidth,
  size,
  width,
  ...otherProps
}) => {
  return (
    <svg
      className={(classes.Icon, className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.49 10"
      width={size || width || '100%'}
      height={size || height || '100%'}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      {...otherProps}
    >
      <path
        id="Icon_ionic-ios-arrow-back"
        data-name="Icon ionic-ios-arrow-back"
        d="M3.015,8.743,9.633,2.13A1.25,1.25,0,0,0,7.862.365L.364,7.858A1.247,1.247,0,0,0,.328,9.581l7.53,7.545a1.25,1.25,0,1,0,1.77-1.765Z"
        transform="translate(17.49) rotate(90)"
        fill={fill}
      />
    </svg>
  );
};

export default memo(IconArrowUp);
